/* eslint-disable react/prop-types */
import { TextField as MuiTextField } from '@mui/material'
import { CSSProperties } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { FieldWrapper } from './FieldWrapper'
import { get as _get } from 'lodash'
import { NumericFormat, OnValueChange } from 'react-number-format'

interface TextFieldProps {
  name: string
  label?: string
  placeholder?: string
  type?: string
  style?: CSSProperties
  inputProps?: any
  mask?: string
  autoFocus?: boolean
  sx?: any
  multiline?: boolean
  rows?: number
  normalize?: (value: string) => void
  onChange?: (e: any) => void
  disabled?: boolean
  InputProps?: any
  loading?: boolean
  hidePrefix?: boolean
  prefix?: string
  suffix?: string
  onValueChange?: OnValueChange
  onBlur?: (
    e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>
  ) => void
}

export const NumberFieldC = (props: TextFieldProps) => {
  const {
    label,
    placeholder,
    style,
    name,
    onChange,
    onBlur,
    normalize,
    disabled,
    prefix,
    suffix
  } = props

  const { formState } = useFormContext()
  return (
    <Controller
      name={name}
      render={({ field }) => (
        <FieldWrapper error={_get(formState.errors, name)}>
          <NumericFormat
            thousandSeparator="."
            decimalSeparator=","
            allowedDecimalSeparators={[',', '.']}
            valueIsNumericString
            prefix={prefix}
            suffix={suffix}
            decimalScale={2}
            fixedDecimalScale
            customInput={MuiTextField}
            {...field}
            onValueChange={(values, sources) => {
              if (sources.source !== 'prop') {
                onChange?.({ target: { value: values.floatValue } })
              }
              if (normalize) {
                // console.log('normalize')
                field.onChange(normalize(values.value))
              } else {
                // console.log('else', values.floatValue)
                field.onChange({ target: { value: values.floatValue } })
              }
            }}
            onChange={() => {
              /* empty */
            }}
            onBlur={(e) => {
              onBlur?.(e)
              field.onBlur()
            }}
            label={label}
            disabled={!!disabled}
            error={!!_get(formState.errors, name)}
            placeholder={placeholder}
            size="small"
            onFocus={(e) => e.target.select()}
            onWheel={(e: any) => {
              e?.target?.blur?.()
            }}
            style={{
              width: '100%',
              height: '100%',
              ...style
            }}
          />
        </FieldWrapper>
      )}
    />
  )
}
